// This file now only contains types and constants.
// Data fetching is now handled by React Query hooks in useFileEntryQueries.ts

export enum FILE_UPLOAD_TYPE {
  FERTILISER_RECEIPT = "FERTILISER_RECEIPT",
  FERTILISER_BAG = "FERTILISER_BAG",
  SEED_MIXES_RECEIPT = "SEED_MIXES_RECEIPT",
  SEED_MIXES_BAG = "SEED_MIXES_BAG",
  FIELD_IMAGES = "FIELD_IMAGES",
  SOIL_TEST_REPORT = "SOIL_TEST_REPORT",
  WATER_TEST_REPORT = "WATER_TEST_REPORT",
  MILK_RECORDING_REPORT = "MILK_RECORDING_REPORT",
  CARCASS_REPORT = "CARCASS_REPORT",
  CARBON_AUDIT_REPORT = "CARBON_AUDIT_REPORT",
  SOIL_ENVIRONMENT_REPORT = "SOIL_ENVIRONMENT_REPORT",
  DETAILED_NUTRIENT_MANAGEMENT_PLAN = "DETAILED_NUTRIENT_MANAGEMENT_PLAN",
  BIODIVERSITY_ACTION_PLAN = "BIODIVERSITY_ACTION_PLAN",
  BIODIVERSITY_HABITAT_MAP = "BIODIVERSITY_HABITAT_MAP",
  SFI_ADVICE_REPORT = "SFI_ADVICE_REPORT",
  BIODIVERSITY_SUMMARY_FLOWER = "BIODIVERSITY_SUMMARY_FLOWER",
  ACTION_EVIDENCE_PHOTO = "ACTION_EVIDENCE_PHOTO",
  ACTION_EVIDENCE_FILE = "ACTION_EVIDENCE_FILE",
}

export const FILE_ENTRY_REJECTION_PERIOD_DAYS = 30;
